import React, { useState, useCallback, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import TextBlock from '../../form/blocks/TextBlock';
import DropdownBlock from '../../form/blocks/DropdownBlock';
import { convertToLocaleTime } from '../../../utils/timeConversion'
import { convertToUtcTime } from '../../../utils/timeConversion'
import axios from 'axios';
import { config } from '../../../utils/config';
import NumberBlock from '../../form/blocks/NumberBlock';
import CommonModal from '../../common/CommonModal';

export default function Bidding({ listingId }) {
    const [show, setShow] = useState(false);
    const [scheduleConfirmation, setScheduleConfirmation] = useState(false)
    const [startDateTime, setStartDateTime] = useState("");
    const [endDateTime, setEndDateTime] = useState("");
    const [utcStartTime, setUtcStartTime] = useState("");
    const [utcEndTime, setUtcEndTime] = useState("");
    const [bidType, setBidType] = useState("");
    const [reservePrice, setReservePrice] = useState(0);
    const [openBid, setOpenBid] = useState(0);
    const [bidIncrement, setBidIncrement] = useState(0);
    const [status, setStatus] = useState("");
    const [bidId, setBidId] = useState(null);
    const [deposit, setDeposit] = useState(0);
    const [selection] = useState([{
        biddingTypes: ["", "Open Bidding", "Sealed Bidding", "Dutch Auction"],
        statusTypes: ["", "In Progress", "Completed", "Withdrawn"]
    }])

    useEffect(() => {

        if (bidType === "Sealed Bidding") {
            setReservePrice(0)
            setOpenBid(0)
            setBidIncrement(0)
        }

    }, [bidType])

    useEffect(()=> {

        setUtcStartTime(convertToUtcTime(startDateTime))
        setUtcEndTime(convertToUtcTime(endDateTime))

    },[startDateTime, endDateTime])



    const handleClose = () => {
        setShow(false);
    }

    const handleShow = useCallback(async () => {

        const response = await axios.get(`${config.apiBaseUrl}/manage/bidding/`, {
            params: {
                listingId
            }
        })
        const bidDetail = response.data

        if (bidDetail) {
            setBidId(bidDetail.id)
            setBidType(bidDetail.bid_type)
            setDeposit(bidDetail.deposit)
            setStatus(bidDetail.status)
        }

        if (bidDetail.start_time || bidDetail.end_time) {
            setStartDateTime(convertToLocaleTime(bidDetail.start_time))
            setEndDateTime(convertToLocaleTime(bidDetail.end_time))
        }

        if (bidDetail.bidSettings) {
            setReservePrice(bidDetail.bidSettings.reserve_price)
            setOpenBid(bidDetail.bidSettings.opening_bid)
            setBidIncrement(bidDetail.bidSettings.bid_increment)
        }

        setShow(true);

    }, [listingId])

    const submitBidDetail = useCallback(async () => {

        const data = await axios.post(`${config.apiBaseUrl}/manage/bidding/create`, {
            listingId,
            utcStartTime,
            utcEndTime,
            deposit,
            bidType,
            reservePrice,
            openBid,
            bidIncrement,
            status
        }, { withCredentials: true })
        console.log(data)

        if (data.data) {
            setShow(false)
            setScheduleConfirmation(true)
        }



    }, [bidType, deposit, reservePrice, openBid, bidIncrement, status, utcStartTime, utcEndTime, listingId])

    const updateBidDetail = useCallback(async () => {

        const data = await axios.put(`${config.apiBaseUrl}/manage/bidding/update`, {
            bidId,
            startDateTime,
            endDateTime,
            deposit,
            bidType,
            reservePrice,
            openBid,
            bidIncrement,
            status
        }, { withCredentials: true })
        console.log(data)

        if (data.data) {
            setShow(false)
            setScheduleConfirmation(true)
        }


    }, [bidId, bidType, endDateTime, deposit, startDateTime, reservePrice, openBid, bidIncrement, status])

    return (
        <>
            <Button variant="danger" size="sm" onClick={handleShow}>
                Schedule Bidding
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Schedule for Bidding</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {/* {recordFound ?
                        <div> */}
                    <DropdownBlock label="Type of Bidding" option={selection.map((d) => d.biddingTypes)} updateParentValue={(value) => { setBidType(value) }} value={bidType} />
                    <TextBlock label="Start Date & Time" type="datetime-local" updateParentValue={(value) => { setStartDateTime(value) }} value={startDateTime} />
                    <TextBlock label="End Date & Time" type="datetime-local" updateParentValue={(value) => { setEndDateTime(value) }} value={endDateTime} />
                    <NumberBlock label="Deposit Amount" updateParentValue={(value) => { setDeposit(value) }} prefix={"$"} suffix={""} value={deposit} />
                    {bidType === 'Sealed Bidding' ? null :
                        <div>
                            <NumberBlock label="Reserved Price" updateParentValue={(value) => { setReservePrice(value) }} prefix={"$"} value={reservePrice} />
                            <NumberBlock label="Opening Bid" updateParentValue={(value) => { setOpenBid(value) }} prefix={"$"} suffix={""} value={openBid} />
                            <NumberBlock label="Bid Increment" updateParentValue={(value) => { setBidIncrement(value) }} prefix={"$"} suffix={""} value={bidIncrement} />
                        </div>}
                    <DropdownBlock label="Status" option={selection.map((d) => d.statusTypes)} updateParentValue={(value) => { setStatus(value) }} value={status} />
                    {/* </div> 
                        :
                        <div>
                            <DropdownBlock label="Type of Bidding" option={selection.map((d) => d.biddingTypes)} updateParentValue={(value) => { setBidType(value) }} value={bidData.bid_type} />
                            <TextBlock label="Start Date & Time" type="datetime-local" updateParentValue={(value) => { setStartDateTime(value) }} value={bidData.start_time ? convertToLocaleTime((bidData.start_time)) : undefined} />
                            <TextBlock label="End Date & Time" type="datetime-local" updateParentValue={(value) => { setEndDateTime(value) }} value={bidData.end_time ? convertToLocaleTime((bidData.end_time)) : undefined} />
                            {bidType === 'Sealed Bidding' ? null :
                                <div>
                                    <NumberBlock label="Reserved Price" updateParentValue={(value) => { setReservePrice(value) }} prefix={"$"} value={bidData.bidSettings ? bidData.bidSettings.reserve_price : undefined} />
                                    <NumberBlock label="Opening Bid" updateParentValue={(value) => { setOpenBid(value) }} prefix={"$"} suffix={""} value={bidData.bidSettings ? bidData.bidSettings.opening_bid : undefined} />
                                    <NumberBlock label="Bid Increment" updateParentValue={(value) => { setBidIncrement(value) }} prefix={"$"} suffix={""} value={bidData.bidSettings ? bidData.bidSettings.bid_increment : undefined} />
                                </div>}
                            <DropdownBlock label="Status" option={selection.map((d) => d.statusTypes)} updateParentValue={(value) => { setStatus(value) }} value={bidData.status} />
                        </div>} */}
                </Modal.Body>
                <Modal.Footer>
                    {bidId ?
                        <Button variant="danger" onClick={updateBidDetail}>Update</Button>
                        :
                        <Button variant="danger" onClick={submitBidDetail}>Submit</Button>
                    }
                </Modal.Footer>
            </Modal>

            <CommonModal title="Bidding Schedule" message="Bidding Scheduled Created" show={scheduleConfirmation} handleClose={() => { setScheduleConfirmation(false) }} />
        </>
    );
}


